import { countryRegionData } from './countryRegionData'

export const getCountryShort = (short: string) => countryRegionData.find((e) => e.short === short)
export const getCountryLong = (long: string) => countryRegionData.find((e) => e.long === long)
